import { createFileRoute, redirect } from '@tanstack/react-router';
import { HelpdeskPage } from '@pages/helpdesk';
import { DEFAULT_LOCALE, isValidLocale, syncLanguageFromUrl } from '@shared/config/i18n';

/** A public page outside the website's locale layout; requester policy still owns access. */
export const Route = createFileRoute('/$locale_/helpdesk')({
  beforeLoad: ({ params }) => {
    if (!isValidLocale(params.locale)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirects are thrown.
      throw redirect({ to: '/$locale/helpdesk', params: { locale: DEFAULT_LOCALE } });
    }
    syncLanguageFromUrl(params.locale);
  },
  component: HelpdeskRoute,
});

function HelpdeskRoute() {
  const { locale } = Route.useParams();
  return <HelpdeskPage locale={locale === 'ru' ? 'ru' : 'en'} />;
}
